<template>
  <div>
<!-- =========== Start of Loader ============ -->
    <!-- <div class="preloader">
        <div class="wrapper">
            <div class="blobs">
                <div class="blob-center"></div>
                <div class="blob"></div>
                <div class="blob"></div>
                <div class="blob"></div>
                <div class="blob"></div>
                <div class="blob"></div>
                <div class="blob"></div>
            </div>
            <div>
                <div class="loader-canvas canvas-left"></div>
                <div class="loader-canvas canvas-right"></div>
            </div>
        </div>
    </div> -->
    <!-- =========== End of Loader ============ -->

    <main class="main">
        <!-- =========== Start of Navigation (main menu) ============ -->
       <Header></Header>
        <!-- =========== End of Navigation (main menu)  ============ -->

        <!-- =========== End of Spacer ============ -->
        <div class="pt-8 pt-lg-8"></div>
        <!-- =========== End of Spacer ============ -->

        <!-- =========== Start of Breadcrumb ============ -->
        <section class="breadcrumb--v1 bg-color--primary-light--1 py-3 py-lg-3">
            <div class="container">
                <div class="row">
                    <div class="col">
                        <nav aria-label="breadcrumb">
                            <ol class="breadcrumb bg-color--transparent">
                                <li class="breadcrumb-item"><router-link to="/" >خانه</router-link></li>
                                <li class="breadcrumb-item active">وبلاگ</li>
                            </ol>
                        </nav>
                        <!-- end of breadcrumb nav -->
                    </div>
                    <!-- end of col -->
                </div>
                <!-- end of row -->
            </div>
            <!-- end of container -->
        </section>
        <!-- =========== End of Breadcrumb ============ -->

        <!-- =========== Start of Blog Body ============ -->
        <section class="pb-3 pt-0 blog-articles bg-color--primary-light--1">
            <div class="container">
                <div class="row">
                    <div class="col-12 mb-3 mb-lg-6">
                        <article class="article sticky sticky--featured">
                            <div class="card">
                                <div class="article__thumbnail">
                                    <div class="article__thumbnail-image">
                                        <img src="/assets/img/blog-page-img-1.jpg" alt="thumbnail" class="card-img-top background-image-holder">
                                    </div>
                                </div>
                                <!-- end of image -->
                                <div class="card-body">
                                    <span class="label label--sm btn-bg--cta--4 mb-2 rounded--05">ویژه</span>
                                    <router-link to="/blog/2" class="article__title">
                                        <h2>چگونه کالای خوب ایرانی بخرم؟</h2>
                                    </router-link>
                                   
                                    
                                </div>
                                <!-- end of body content -->
                            </div>
                        </article>
                    </div>
                    <!-- end of featured sticky post col -->
                    <div class="col-12">
                        <div class="row mb-2">
                            <div class="col-12 col-sm-6 col-lg-4 mb-3">
                                <article class="article article--no-image sticky sticky--regular">
                                    <div class="card">
                                        <div class="article__thumbnail">
                                            <div class="article__thumbnail-image">
                                                <img src="/assets/img/blog-page-img-2.jpg" alt="thumbnail" class="card-img-top background-image-holder">
                                            </div>
                                        </div>
                                        
                                        <div class="card-body">
                                            <router-link to="/blog/2" class="article__title">
                                                <h2>چگونه کالای قسطی بخرم؟</h2>
                                            </router-link>
                                            <span class="article__date">۲۲ آبان ۱۳۹۸</span>
                                        </div>
                                        <!-- end of body content -->
                                    </div>
                                </article>
                                <!-- end of single card -->
                            </div>
                            <!-- end of single card col-->
                            <div class="col-12 col-sm-6 col-lg-4 mb-3">
                                <article class="article">
                                    <div class="card">
                                        <div class="article__thumbnail">
                                            <div class="article__thumbnail-image">
                                                <img src="/assets/img/blog-page-img-3.jpg" alt="thumbnail" class="card-img-top background-image-holder">
                                            </div>
                                        </div>
                                       
                                        <div class="card-body">
                                            <router-link to="/blog/2"  class="article__title">
                                                <h2>ویژگی یک یخچال خوب چیست؟</h2>
                                            </router-link>
                                            <span class="article__date">۱۳ دی ۱۳۹۸</span>
                                        </div>
                                        <!-- end of body content -->
                                    </div>
                                </article>
                                <!-- end of single card -->
                            </div>
                            <!-- end of single card col-->
                            <div class="col-12 col-sm-6 col-lg-4 mb-3">
                                <article class="article">
                                    <div class="card">
                                        <div class="article__thumbnail">
                                            <div class="article__thumbnail-image">
                                                <img src="/assets/img/blog-page-img-4.jpg" alt="thumbnail" class="card-img-top background-image-holder">
                                            </div>
                                        </div>
                                        
                                        <div class="card-body">
                                            <router-link to="/blog/2" class="article__title">
                                                <h2>معرفی تلویزیون های با کیفیت ایرانی</h2>
                                            </router-link>
                                            <span class="article__date">۱۴ بهمن ۱۳۹۸</span>
                                        </div>
                                        <!-- end of body content -->
                                    </div>
                                </article>
                                <!-- end of single card -->
                            </div>
                            <!-- end of single card col-->
                            <div class="col-12 col-sm-6 col-lg-4 mb-3">
                                <article class="article">
                                    <div class="card">
                                        <div class="article__thumbnail">
                                            <div class="article__thumbnail-image">
                                                <img src="/assets/img/blog-page-img-5.jpg" alt="thumbnail" class="card-img-top background-image-holder">
                                            </div>
                                        </div>
                                        
                                        <div class="card-body">
                                            <router-link to="/blog/2" class="article__title">
                                                <h2>ملاک های خرید یک ماشین لباسشویی چیست؟</h2>
                                            </router-link>
                                            <span class="article__date">۳ دی ۱۳۹۸</span>
                                        </div>
                                        <!-- end of body content -->
                                    </div>
                                </article>
                                <!-- end of single card -->
                            </div>
                            <!-- end of single card col-->
                            <div class="col-12 col-sm-6 col-lg-4 mb-3">
                                <article class="article">
                                    <div class="card">
                                        <div class="article__thumbnail">
                                            <div class="article__thumbnail-image">
                                                <img src="/assets/img/blog-page-img-6.jpg" alt="thumbnail" class="card-img-top background-image-holder">
                                            </div>
                                        </div>
                                        
                                        <div class="card-body">
                                            <router-link to="/blog/2" href="#" class="article__title">
                                                <h2>چگونه خدمات قسطی دریافت کنیم؟</h2>
                                            </router-link>
                                            <span class="article__date">۱ آذر ۱۳۹۸</span>
                                        </div>
                                        <!-- end of body content -->
                                    </div>
                                </article>
                                <!-- end of single card -->
                            </div>
                            <!-- end of single card col-->
                            <div class="col-12 col-sm-6 col-lg-4 mb-3">
                                <article class="article">
                                    <div class="card">
                                        <div class="article__thumbnail">
                                            <div class="article__thumbnail-image">
                                                <img src="/assets/img/blog-page-img-7.jpg" alt="thumbnail" class="card-img-top background-image-holder">
                                            </div>
                                        </div>
                                        
                                        <!-- end of author avatar & name -->
                                        <div class="card-body">
                                            <router-link to="/blog/2" class="article__title">
                                                <h2>ویژگی های یک فرش خوب چیست؟</h2>
                                            </router-link>
                                            <span class="article__date">۶ اسفند ۱۳۹۸</span>
                                        </div>
                                        <!-- end of body content -->
                                    </div>
                                </article>
                                <!-- end of single card -->
                            </div>
                            <!-- end of single card col-->
                        </div>
                        <!-- end of blog post row -->
                        <div class="row">
                            <div class="col">
                                <nav>
                                    <ul class="pagination justify-content-center">
                                        <li class="page-item"><router-link to="/blog" class="page-link">قبلی</router-link></li>
                                        <li class="page-item active"><router-link to="/blog" class="page-link">1</router-link></li>
                                        <li class="page-item"><router-link to="/blog" class="page-link">2</router-link></li>
                                        <li class="page-item"><router-link to="/blog" class="page-link">3</router-link></li>
                                        <li class="page-item page-item--page-gap">...</li>
                                        <li class="page-item"><router-link to="/blog" class="page-link">بعدی</router-link></li>
                                    </ul>
                                </nav>
                                <!-- end of pagination -->
                            </div>
                            <!-- end of pagination col -->
                        </div>
                        <!-- end of pagination row -->
                    </div>
                    <!-- end of blog post body col -->
                </div>
                <!-- end of row -->
            </div>
            <!-- end of container -->
        </section>
        <!-- =========== End of Blog Body ============ -->

        <!-- =========== Start of Footer ============ -->
        <Footer></Footer>
        <!-- =========== End of Footer ============ -->

    </main>

  </div>
</template>

<script>
// @ is an alias to /src
import Header from '@/components/shared/Header'
import Footer from '@/components/shared/Footer'
export default {
  name: 'home',
  components: {
   
    Footer,
    Header
  }
}
</script>